import React from 'react'

import {
    InputGroup,
    InputGroupAddon,
    FormGroup
} from 'reactstrap'
import { MdEmail } from 'react-icons/md'
import { StyledInput, InvalidFeedback } from './styled'

export default ( field ) => {
    const { meta: {error, touched} } = field
    const isInvalid = touched && error ? true : false
    const colorClass = touched && error ? 'danger' : 'primary'

    return(
        <FormGroup>
            <InputGroup className={`border-bottom border-${colorClass}`}>
                <InputGroupAddon addonType="prepend" className='d-flex align-items-end'>
                    <MdEmail size={25} className={`text-${colorClass} mx-3 mb-2`}/>
                </InputGroupAddon>
                <StyledInput
                    type={field.type}
                    name={field.name}
                    placeholder={field.placeholder}
                    invalid={isInvalid}
                    autoComplete={field.autocomplete}
                    className={field.class}
                    {...field.input}
                />
            </InputGroup>
            <InvalidFeedback className='mx-3 text-danger'>{ isInvalid ? error : ''}</InvalidFeedback>
        </FormGroup>
    )
}